import type { ReactNode } from 'react';
import { useT } from '../../../messages';
import type { Step } from './steps';
import { follow } from './go';
import type { Moves } from './go';

/**
 * **The next step, always first** — the one thing to do now, lifted out of the
 * checklist below it (`nextStep` in `steps.ts` picks it). Before the
 * redesign nothing on the page said what came next; the operator worked it out
 * from fifteen cards.
 *
 * Its action is the step's own, so the banner and the checklist line go to the
 * same place. A step with no console action (a staff invite goes out from the
 * operator tool) says so in its detail and draws no button.
 */
export function NextStep({ step, moves }: { step: Step; moves: Moves }): ReactNode {
  const t = useT();
  return (
    <section className="ov-next" aria-label={t('overview.next', { step: step.next })}>
      <div>
        <h2>{t('overview.next', { step: step.next })}</h2>
        <p>
          {step.detail}
          {step.who === 'owner' ? <> · {t('overview.next.owner')}</> : null}
        </p>
      </div>
      {step.action === null ? null : (
        <button
          type="button"
          className="button button--primary"
          onClick={() => {
            if (step.action !== null) follow(moves, step.action.go);
          }}
        >
          {step.action.label}
        </button>
      )}
    </section>
  );
}
